// Auto-generated by scripts/set-env.js — do NOT commit this file
export const environment = {
  production: false,
  platformApiURL: 'https://api.ltiv1p3.platform.alpha.development.hallopflege.net',
  allowDebug: true,
  testUserEmail:'test@relias.de'
};
